import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import SvgContainer from "src/components/SvgContainer";
import { Activities } from "src/modules/activity-log/activity";
import { ReactComponent as PremiumIcon } from "./premium.svg";

export default function PremiumBanner({ mode, activity, onClick }) {
  const { t } = useTranslation();

  if (mode === "audio" && activity === Activities.AWAKE) {
    return null;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      onClick={onClick}
      bg="primary"
      py="8px"
      pr="16px"
      pl="16px"
      borderRadius="16px"
      minWidth="128px"
    >
      <SvgContainer icon={PremiumIcon} size="16px" />
      <Text
        fontSize="12px"
        fontWeight="600"
        lineHeight="1.17"
        letterSpacing="0.15"
        color="white"
      >
        {t("noFreeTimeDialog.trial.openPurchaseButton")}
      </Text>
    </Flex>
  );
}
